
export const rbac = {

    // admin role
    'superuser': {
        // --> permissions
        // resources
        'admin': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'users': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'patients': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'consultations': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'appointment': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'expense': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'facility': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'branch': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'staffs': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'reports': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'calls': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'pharmacies': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'laboratories': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'insurances': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'serviceProviders': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'memberships': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },

        'network': {
            'canRead': true,
            'canUpdate': true,
        },
        'charges': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'services': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'deliveries': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'incidents': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'bills': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
    },

    // admin role
    'admin': {
        'admin': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': false,
        },
        'users': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'patients': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'consultations': {
            'canCreate': true,
            'canRead': true,
        },
        'facility': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': false,
        },
        'branch': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'expense': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'appointment': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'staffs': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'reports': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'calls': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'pharmacies': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'laboratories': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'insurances': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'serviceProviders': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'memberships': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
        },
        'network': {
            'canRead': true,
        },
        'charges': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'services': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'cards': {
            'canCreate': true,
            'canRead': true,
        },
        'deliveries': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'incidents': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
        },
        'bills': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
    },

    'doctor': {
        'users': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
        },
        'patients': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'consultations': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'appointment': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': false,
        },
        'facility': {
            'canRead': true,
        },
        'branch': {
            'canRead': true,
        },
        'expense': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': false,
        },
        'staffs': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': false,
        },
        'reports': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'calls': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'pharmacies': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': false,
        },
        'laboratories': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': false,
        },
        'insurances': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': false,
            'canDelete': false,
        },
        'serviceProviders': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': false,
            'canDelete': false,
        },
        'memberships': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
        },
        'network': {
            'canRead': true,
        },
        'charges': {
            'canCreate': true,
            'canRead': true,
        },
        'services': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
        },
        'cards': {
            'canCreate': true,
            'canRead': true,
        },
        'deliveries': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
        },
        'incidents': {
            'canCreate': true,
            'canRead': false,
            'canUpdate': false,
        },
        'bills': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
    },

    'nurse': {
        'patients': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': false,
        },
        'consultations': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': false,
        },
        'appointment': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': false,
        },
        'calls': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': false,
            'canDelete': false,
        },
        'pharmacies': {
            'canCreate': false,
            'canRead': true,
            'canUpdate': false,
            'canDelete': false,
        },
        'expense': {
            'canCreate': true,
            'canRead': false,
            'canUpdate': false,
            'canDelete': false,
        },
        'laboratories': {
            'canCreate': false,
            'canRead': true,
            'canUpdate': false,
            'canDelete': false,
        },
        'insurances': {
            'canCreate': false,
            'canRead': true,
            'canUpdate': false,
            'canDelete': false,
        },
        'serviceProviders': {
            'canCreate': false,
            'canRead': true,
            'canUpdate': false,
            'canDelete': false,
        },
        'memberships': {
            'canCreate': true,
            'canRead': true,
        },
        'network': {
            'canRead': true,
        },
        'staffs': {
            'canRead': true,
        },
        'charges': {
            'canCreate': true,
            'canRead': true,
        },
        'services': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
        },
        'cards': {
            'canCreate': true,
            'canRead': true,
        },
        'deliveries': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
        },
        'incidents': {
            'canCreate': true,
            'canRead': false,
        },
        'bills': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
        },
    },

    'frontdesk': {
        'patients': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': false,
        },
        'consultations': {
            'canCreate': true,
            'canRead': true,
        },
        'appointment': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': true,
        },
        'expense': {
            'canCreate': true,
            'canRead': false,
            'canUpdate': false,
            'canDelete': false,
        },
        'calls': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
            'canDelete': false,
        },
        'pharmacies': {
            'canCreate': false,
            'canRead': true,
            'canUpdate': false,
            'canDelete': false,
        },
        'laboratories': {
            'canCreate': false,
            'canRead': true,
            'canUpdate': false,
            'canDelete': false,
        },
        'insurances': {
            'canCreate': false,
            'canRead': true,
            'canUpdate': false,
            'canDelete': false,
        },
        'serviceProviders': {
            'canCreate': false,
            'canRead': true,
            'canUpdate': false,
            'canDelete': false,
        },
        'memberships': {
            'canCreate': true,
            'canRead': true,
        },
        'network': {
            'canRead': true,
        },
        'staffs': {
            'canRead': true,
        },
        'charges': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
        },
        'services': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
        },
        'cards': {
            'canCreate': true,
            'canRead': true,
        },
        'incidents': {
            'canCreate': true,
            'canRead': false,
        },
        'bills': {
            'canCreate': true,
            'canRead': true,
            'canUpdate': true,
        },
    },

    'partner': {
        'patients': {
            'canRead': true,
        },
        'reports': {
            'canRead': true,
        },
    },

    'laboratory': {
        'consultations': {
            'canRead': true,
            'canUpdate': true,
        },
        'charges': {
            'canRead': true,
        },
        'services': {
            'canRead': true,
        },
    },

    'pharmacy': {
        'consultations': {
            'canRead': true,
            'canUpdate': true,
        },
        'charges': {
            'canRead': true,
        },
        'services': {
            'canRead': true,
        },
    },

};
